<div class="modal fade" id="exampleModalToggle" data-bs-keyboard="false" aria-hidden="true" role="dialog" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content modal-contentx">
        <div class="modal-body modal-bodyx">
          <app-show-stories></app-show-stories>
        </div>
      </div>
    </div>
  </div>
  

<div class="container mt-5">
    <div class="row">
        <div class="col-md-12 mx-auto">
            <div class="cards">
                <div class="card-body">
                    <h5 class="card-title mb-4">Stories</h5>
                    <div class="owl-carouselx owl-themex">
                        <owl-carousel-o [options]="customOptions">
                            <ng-template carouselSlide>
                                <div class="item" data-bs-toggle="modal" href="#exampleModalToggle"  >
                                    <div class="story-circle">
                                        <!-- <img src="https://i.pravatar.cc/60?img=2" alt="User 1"> -->
                                    </div>
                                    <div class="add-story-icon">
                                        <a href="#" data-bs-toggle="modal" data-bs-target="#create_modal-story">+</a>
                                      </div>
                                    <p class="story-username">Add Story</p>
                                </div>
                            </ng-template>  
                            <ng-template carouselSlide *ngFor="let user of storedList">
                                <div class="item" data-bs-toggle="modal" href="#exampleModalToggle">
                                  <div class="story-circle">
                                    <!-- <img [src]="user.imgUrl" [alt]="user.EMAIL_ADDRESS"> -->
                                  </div>
                                  <p class="story-username">{{ user.EMAIL_ADDRESS }}</p>
                                </div>
                              </ng-template> 
                            <ng-template carouselSlide>
                                <div class="item" data-bs-toggle="modal" href="#exampleModalToggle"  >
                                    <div class="story-circle">
                                        <img src="https://i.pravatar.cc/60?img=2" alt="User 1">
                                    </div>
                                    <p class="story-username">user1</p>
                                </div>
                            </ng-template>  
                            <ng-template carouselSlide>
                                <div class="item" data-bs-toggle="modal" href="#exampleModalToggle"  >
                                    <div class="story-circle">
                                        <img src="https://i.pravatar.cc/60?img=2" alt="User 1">
                                    </div>
                                    <p class="story-username">user1</p>
                                </div>
                            </ng-template>     
                        </owl-carousel-o>
                      
                      
                   </div>

                </div>
            </div>
        </div>
    </div>
</div>






